@if(count > 0){
<div class="but" (click)="redirect()">
  <button>
    <div class="counter">{{ count }}</div>
    {{MyOrderList()}}
  </button>
  <svg class="navigation__icon">
    <use xlink:href="images/sprites9.svg#icon-angle-double-right"></use>
  </svg>
</div>
}
